// @ts-ignore
import styles from './PlanTimeline.module.scss';
import Text from '../../Base/Text/Text';
import { joinClasses } from '../../../Utils/className.util';
import React from 'react';
import useTranslation from '../../../Hooks/useTranslation';

const PlanTimelineLegend: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className={styles.legend}>
			<div className={styles.legendTitle}>
				<Text tx='component.ePrescription.legend' inline />:
			</div>
			<div className={styles.legendItem}>
				<div
					className={joinClasses([
						styles.legendItemBubble,
						styles.haveToFillNow,
					])}
				/>
				<div className={styles.legendItemTitle}>
					{t('base.youHaveToFillNow')}
				</div>
			</div>
			<div className={styles.legendItem}>
				<div
					className={joinClasses([styles.legendItemBubble, styles.canFillNow])}
				/>
				<div className={styles.legendItemTitle}>{t('base.youCanFillNow')}</div>
			</div>
			<div className={styles.legendItem}>
				<div
					className={joinClasses([styles.legendItemBubble, styles.cantFillNow])}
				/>
				<div className={styles.legendItemTitle}>{t('base.youCantFillNow')}</div>
			</div>
			<div className={styles.legendItem}>
				<div
					className={joinClasses([styles.legendItemBubble, styles.scheduled])}
				/>
				<div className={styles.legendItemTitle}>{t('base.planned')}</div>
			</div>
			<div className={styles.legendItem}>
				<div
					className={joinClasses([styles.legendItemBubble, styles.completed])}
				/>
				<div className={styles.legendItemTitle}>{t('base.completed')}</div>
			</div>
		</div>
	);
};

export default PlanTimelineLegend;
